module.exports = "<div class=\"container\">\r\n  <app-trips-escalations\r\n    (loadingMask)=\"onLoadingMaskEmit($event)\">\r\n  </app-trips-escalations>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/escalations/escalations.component.html
// module id = 2442
// module chunks = 66